// Runs only inside the sandbox. The model supplies markup, never executable code.
export function installGenesisInteractions(doc) {
  const displays = new WeakMap();
  function update(input) {
    const id = input.getAttribute('data-genesis-search');
    const list = doc.getElementById(id);
    if (!list) return;
    const query = input.value.trim().toLocaleLowerCase();
    const items = Array.from(list.querySelectorAll('[data-genesis-record]'));
    for (const item of items) {
      if (!displays.has(item))
        displays.set(item, [
          item.style.getPropertyValue('display'),
          item.style.getPropertyPriority('display'),
        ]);
      item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
      // Generated CSS may override native [hidden]; filtering must remain reliable.
      if (item.hidden) item.style.setProperty('display', 'none', 'important');
      else {
        const [value, priority] = displays.get(item);
        if (value) item.style.setProperty('display', value, priority);
        else item.style.removeProperty('display');
      }
    }
    const count = items.filter((item) => !item.hidden).length;
    for (const output of doc.querySelectorAll('output[data-genesis-count]')) {
      if (
        !output.contains(list) &&
        output.getAttribute('data-genesis-count') === id
      )
        output.textContent = String(count);
    }
  }
  for (const input of doc.querySelectorAll('input')) {
    if (input.type !== 'search' || !input.hasAttribute('data-genesis-search')) {
      input.remove();
      continue;
    }
    input.autocomplete = 'off';
    update(input);
  }
  for (const output of doc.querySelectorAll('output[data-genesis-count]')) {
    const list = doc.getElementById(output.getAttribute('data-genesis-count'));
    if (list && !output.contains(list))
      output.textContent = String(
        Array.from(list.querySelectorAll('[data-genesis-record]')).filter(
          (item) => !item.hidden
        ).length
      );
  }
  doc.addEventListener('input', (event) => {
    if (event.target.matches('input[type="search"][data-genesis-search]'))
      update(event.target);
  });
}
